import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';
import { accountsAdapter } from './accounts';

// acc

const accountsState = (state: RootState) => state.accounts;

export const selectAccountDmas = createSelector([accountsState], (state) => state.dmas);
export const selectedAccStateSelector = createSelector([accountsState], (state) => ({
  ...state,
  subaccounts: accountsAdapter.getSelectors().selectAll(state.subaccounts),
}));
